import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "drag-el__text" }
const _hoisted_2 = { class: "drag-el__count" }
const _hoisted_3 = { class: "drag-el__text" }

import { computed, inject } from "vue";
import { DragGeneralState } from "@/models/interfaces/file/file-model";
import AppIcon from "../ui-kit/icon/AppIcon.vue";
import { typeIconMap } from "@/utils/fileIcons";


export default /*@__PURE__*/_defineComponent({
  __name: 'FileDragElement',
  setup(__props) {

const dragGeneralState = inject<DragGeneralState>("dragGeneralState", {
  name: "",
  type: "",
  count: 0,
  active: false,
  x: 0,
  y: 0,
});



const dragIconName = computed(() => {
  return typeIconMap[dragGeneralState.type] || "file-universal";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: "drag-preview",
      class: "drag-el",
      style: _normalizeStyle({
        left: _unref(dragGeneralState).x + 'px',
        top: _unref(dragGeneralState).y + 'px',
      })
    }, [
      _createVNode(AppIcon, {
        class: "drag-el__icon",
        name: dragIconName.value,
        width: "18px",
        color: "#979797",
        cursor: "pointer"
      }, null, 8, ["name"]),
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(dragGeneralState).name), 1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(dragGeneralState).count), 1)
    ], 4),
    (_unref(dragGeneralState).count > 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "drag-el",
          style: _normalizeStyle({
        zIndex: 99,
        left: _unref(dragGeneralState).x + 4 + 'px',
        top: _unref(dragGeneralState).y + 4 + 'px',
      })
        }, [
          _createVNode(AppIcon, {
            class: "drag-el__icon",
            name: dragIconName.value,
            width: "18px",
            color: "#979797",
            cursor: "pointer"
          }, null, 8, ["name"]),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(dragGeneralState).name), 1)
        ], 4))
      : _createCommentVNode("", true)
  ], 64))
}
}

})